import Cookies from 'js-cookie';

const cookieManager = {
  getAccessToken() {
    return Cookies.get('token');
  },

  setAccessToken(token: string, expiresIn: number) {
    const expires = new Date(new Date().getTime() + expiresIn * 1000);
    Cookies.set('token', token, { expires });
  },

  removeAccessToken() {
    Cookies.remove('token');
  },
};

export default cookieManager;
